import './index.scss'

import React, { useEffect, useState } from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'
import Portal from 'components/Portal'

const bem = new BEMHelper('spinner')

export function LoadingIndicator({ box = true, width, className }) {
  let w = box ? 50 : 100
  let s = box ? 5 : 8

  if (width) {
    w = width
    s = Math.max(1, Math.round(w / 10))
  }

  const c = w / 2
  const r = w / 2 - s
  const path = `
    M ${c - r}, ${c}
    a ${r},${r} 0 1,0 ${r * 2},0
    a ${r},${r} 0 1,0 -${r * 2},0
  `
  const dash = w * 3

  return (
    <span
      style={{
        '--dash': dash,
        width: `${w}px`,
        height: `${w}px`,
      }}
      {...bem('indicator', null, className)}
    >
      <svg
        viewBox={`0 0 ${w} ${w}`}
        style={{
          width: `${w}px`,
          height: `${w}px`,
          strokeWidth: s,
        }}
        {...bem('svg')}
      >
        <path {...bem('line', 'muted')} d={path} />
        <path {...bem('line')} d={path} />
      </svg>
    </span>
  )
}

export default function Spinner({ className, text, full, centered, box = true, delay = 150 }) {
  // Show immediately if delay is set to 0, otherwise not
  const [show, setShow] = useState(delay === 0)

  // Delay showing the loader for the duration specified for the delay prop
  useEffect(() => {
    const _timer = setTimeout(() => {
      setShow(true)
    }, delay || 0)

    return () => clearTimeout(_timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!show) {
    return null
  }

  // Wrap in a portal if it's full screen
  if (full || box) {
    return (
      <Portal>
        <div {...bem('', { full, box, centered }, className)}>
          {box && <span {...bem('text')}>{text || 'Laster'}</span>}

          <LoadingIndicator box={box} />
        </div>
      </Portal>
    )
  }

  return (
    <div {...bem('', { full, box, centered }, className)}>
      {box && <span {...bem('text')}>{text || 'Laster'}</span>}

      <LoadingIndicator box={box} />
    </div>
  )
}

LoadingIndicator.propTypes = {
  box: T.bool,
  width: T.number,
  className: T.string,
}

Spinner.propTypes = {
  className: T.string,
  text: T.string,
  full: T.bool,
  box: T.bool,
  centered: T.bool,
  delay: T.number,
}
